import { Alert, AlertTitle, Box } from "@mui/material"
import { PersonAddOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import { type ReactNode } from "react"

import { Button } from "@/components/common/Button"

const EmptyContactsAlert = ({ handleAddContact }: { handleAddContact: () => void }): ReactNode => {
  return (
    <Alert
      icon={<WarningOutlined color='primary' />}
      severity='info'
      variant='filled'
      classes={{
        message: "w-full flex flex-row justify-between",
      }}
    >
      <Box>
        <AlertTitle className='font-normal leading-7'>
          Add contacts and define their role at locations created
        </AlertTitle>
        <Box className='w-full font-thin'>One contact per location is required</Box>
      </Box>
      <Box className='flex items-center'>
        <Button size='small' appearance='outlined' onClick={handleAddContact}>
          <PersonAddOutlined />
          Add Contact
        </Button>
      </Box>
    </Alert>
  )
}

export default EmptyContactsAlert
